export default __webpack_public_path__ + "static/media/HomeIcon.a5dd263c.svg";